'use strict'
import { post } from '@/utilitys/gecAxios'
import config from './config'
import languageSelect from '@/components/language'
import classroom from '@/components/classroom'
import signStatus from '@/components/signStatus'
export default {
  name: 'gecheadernew',
  components: { languageSelect, classroom, signStatus },
  data () {
    return {
      darkMode: true,
      zh: true,
      isLogin: false,
      logo: false,
      navData: config.NAVLIST,
      noTop: '',
      userData: {
        headImgUrl: 'https://gecacademy.oss-cn-beijing.aliyuncs.com/Virtual%20%20user/15120038756650099.jpg',
        nickName: '',
        phone: ''
      }
    }
  },
  watch: {
    '$i18n.locale': function (val) {
      if (val === 'en') { this.navData = config.NAVLIST.filter((item) => { return item.mark !== 'public' }) }
    }
  },
  computed: {
    language () {
      return this.$i18n.locale.toUpperCase()
    },
    realPath () {
      let path = this.$route.path
      if (this.$i18n.locale === 'en') { path = this.$route.path.replace(/^\/[^\/]+/, '') }
      for (const item of this.navData) {
        if (!item.children) { continue }
        for (const child of item.children) {
          if (child.path === path) { path = item.path; break }
        }
      }
      return path
    }
  },
  created () {
    this.navData = config.NAVLIST
    if (this.$i18n.locale === 'en') {
      this.navData = config.NAVLIST.filter((item) => { return item.mark !== 'public' })
    }
    if (process.browser) { window.addEventListener('scroll', this.handleScroll.bind(this)) }
  },
  mounted () {
    // console.log(this.navData)
    if (this.$route.query.logo === 'yes') {
      this.logo = true
    }
    this.getUserInfo()
  },
  methods: {
    // 登录按钮被点击
    loginClicked () { this.$Message.info('login') },
    jumpLink (link) {
      location.href = `https://${link}`
    },
    async logout () {
      let { data: res } = await post(`/login/logout`)
      if (res.error.returnCode !== 0) return this.$Message.error('登出失败!')
      this.userData = { headImgUrl: '', phone: '', nickName: '' }
      this.isLogin = false
    },
    login () {
      location.href = `https://sso.gecacademy.cn/login?backUrl=${escape(window.location.href)}`
    },
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft
      this.darkMode = scrollTop <= 60
      if (process.browser) { document.querySelector('.gec-header-new-content').style.left = -scrollLeft + 'px' }
    },
    async getUserInfo () {
      let { data: res } = await post(`/login/check`)
      // res = mockLogin
      if (res.error.returnCode === 0) {
        const DATA = res.data
        this.userData = DATA
        this.isLogin = true
      } else {
        this.isLogin = false
      }
    },
    changeLanguage (lang) {
      if (this.$i18n.locale === lang) { return }
      this.$i18n.locale = lang
      // VueCookie.delete('lang')
      // VueCookie.set('lang', lang, { domain: '.gecacademy.cn' })
      // if (lang === 'zh') {
      //   console.log(`当前以中文的条件进入逻辑`)
      //   this.$router.push({ path: this.$route.fullPath.replace(/^\/[^\/]+/, '') })
      // } else if (lang === 'en') {
      //   this.$router.replace({
      //     path: `/${lang}${this.$route.fullPath}`
      //   })
      // }
    },
    backToHomePage () {
      this.$router.replace({ path: `/${this.$i18n.locale}/home` })
    }
    // // 导航被点击
    // headerMenuItemClicked (obj) {
    //   if (process.browser) {
    //     const navList = document.querySelectorAll('.nav-item')
    //     navList.forEach(element => {
    //       element.className = 'nav-item'
    //     })

    //     // this.$Message.success('path');
    //     // const MARK = this.$i18n.locale
    //     // this.$router.replace({
    //     //   path: `/${MARK}${obj.path}`
    //     // })
    //     // console.log(`${obj.path}`)

    //     this.fontActive(`${obj.path}`)
    //   }
    // }
  }
}



// WEBPACK FOOTER //
// ./src/components/gecHeaderNew/gec-header-new.js